import {Component, Input, OnInit} from '@angular/core';
export class CbjLinkCellComponent implements OnInit {
  row: any;
  keys: string[];
  link: string;
  text: string;
/**
 * @return {?}
 */
ngOnInit() {
    this.link = this.row[this.keys[0]];
    this.text = this.row[this.keys[1]];
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cbj-link-cell',
  template: `<ng-container *ngIf="link; else elseBlock">
      <a [routerLink]="link">{{ text }}</a>
  </ng-container>
  <ng-template #elseBlock><span [innerHTML]="text"></span></ng-template>`
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'row': [{ type: Input },],
'keys': [{ type: Input },],
};
}

function CbjLinkCellComponent_tsickle_Closure_declarations() {
/** @type {?} */
CbjLinkCellComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CbjLinkCellComponent.ctorParameters;
/** @type {?} */
CbjLinkCellComponent.propDecorators;
/** @type {?} */
CbjLinkCellComponent.prototype.row;
/** @type {?} */
CbjLinkCellComponent.prototype.keys;
/** @type {?} */
CbjLinkCellComponent.prototype.link;
/** @type {?} */
CbjLinkCellComponent.prototype.text;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
